// extracted by mini-css-extract-plugin
export default {"mapDiv":"CollectorMap_mapDiv__LMb2z","mapButton":"CollectorMap_mapButton__U7SJb"};